import { EsTransactionBaseData } from '../../shared/EsTransactionBaseData';

export class CitesTransactionBaseData extends EsTransactionBaseData {
  authorityLicenseNumber?: string;
  items?: any[] = [];
}
